import { computed } from '@preact/signals'

import { Typography, Button } from 'components'

import { teamMemberCountState } from '../../../state'

// TODO: Get this value from Plans
const MOCK_PRICE = 10

const totalValue = computed(() => teamMemberCountState.value * MOCK_PRICE)

const SelectedPlanCard = () => (
	<div>
		<div class='rounded-md border border-black-800 bg-black-850 p-5'>
			<div class='space-y-4'>
				<Typography color='text-black-100' text='Selected Plan' variant='h5' />

				<div>
					<Typography
						class='inline'
						color='text-black-100'
						text='Community.'
						variant='text3'
						weight='font-bold'
					/>
					<Typography
						class='ml-1 inline'
						color='text-black-100'
						text='The basics for teams that develop open-source dApps.'
						variant='text3'
					/>
				</div>

				<div class='mt-6 flex items-center justify-center'>
					<Typography
						color='text-black-100'
						text={`$${totalValue.value} USD`}
						variant='h1'
						weight='font-normal'
					/>
					<Typography
						class='ml-2 text-lg'
						color='text-black-200'
						text='/monthly'
						variant='label3'
						weight='font-normal'
					/>
				</div>

				<Typography
					class='mt-4 flex justify-center text-center'
					color='text-black-200'
					text={`$${MOCK_PRICE} USD per user`}
					variant='label3'
					weight='font-normal'
				/>
			</div>

			<Button
				className='mt-6 w-full bg-black-500 text-black-100'
				text='Acquire Seats'
				disabled
			/>
		</div>
	</div>
)

export { SelectedPlanCard }
